import { useAiScriptGeneration } from './ai/useAiScriptGeneration';
import { useAiRequestExecution } from './ai/useAiRequestExecution';
import { useAiCollectionWrites } from './ai/useAiCollectionWrites';
export { describeRequestFieldValue, redactTestRunResults } from './ai/aiRequestHelpers';

/**
 * AI assistant tool handlers (create collection/folder/request, move requests,
 * execute request, run collection) + the request-builder send/live-state bridge
 * reads. All domain reads go through store getState(); tab/collection helpers and
 * the bridge refs (shared with selectRequest) are passed in by App.
 *
 * @param {{
 *   scheduleTreeSave: Function, createNewRequestTab: Function, selectRequest: Function,
 *   requestBuilderSendRef: { current: any }, requestBuilderLiveStateRef: { current: any },
 *   collectionRunnerAiResolveRef: { current: any },
 * }} deps
 */
export function useAiActions({
  scheduleTreeSave, createNewRequestTab, selectRequest, requestBuilderSendRef,
  requestBuilderLiveStateRef, collectionRunnerAiResolveRef,
}) {
  const {
    aiCreateCollection, aiCreateFolders, aiCreateRequest, aiMoveRequests, aiUpdateRequest,
  } = useAiCollectionWrites({ scheduleTreeSave });

  const { getCurrentEditorRequest, aiExecuteRequest, aiRunCollection } = useAiRequestExecution({
    selectRequest, createNewRequestTab, requestBuilderSendRef, requestBuilderLiveStateRef,
    collectionRunnerAiResolveRef,
  });

  const {
    aiGetLastResponse,
    aiGenerateTests,
    aiGeneratePreRequestScript,
  } = useAiScriptGeneration();

  return {
    aiCreateCollection, aiCreateFolders, aiCreateRequest, aiMoveRequests, aiExecuteRequest,
    aiRunCollection, getCurrentEditorRequest, aiGetLastResponse, aiGenerateTests,
    aiGeneratePreRequestScript, aiUpdateRequest,
  };
}
